module.exports = __webpack_public_path__ + "img/usage_multi.2ca72e83.png";